import { falsyCheckDate } from 'utils';
import { DataCellProps } from '../types';

export const TeamLastActivityCell = ({ team }: DataCellProps) => {
  return <div>{falsyCheckDate(team.last_user_activity_at)}</div>;
};
